import { theme } from 'antd';
import { EditIcon } from 'assets/images/svg';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { PersonProfileCard } from 'zComponents/atoms';
import { PersonDrawer } from 'zComponents/molecules';
import { Button, Flex } from 'zui/Antd';

const RenderHeaderProfileSetting = () => {
	//Hooks
	const {
		token: { marginMD }
	} = theme.useToken();

	// Redux state
	const { personID } = useSelector((state) => state.Auth.selectedProfile);

	//Local State
	const [visibleEditProfileModal, setVisibleEditProfileModal] = useState(false);

	return (
		<Flex justify={'space-between'} style={{ marginBottom: marginMD }} gap={marginMD} wrap align='start'>
			<PersonProfileCard personID={personID} highlightOnHover={false} size={45} />

			<Button icon={<EditIcon />} style={{ fontWeight: 500 }} onClick={() => setVisibleEditProfileModal(true)}>
				Edit Profile
			</Button>

			<PersonDrawer
				personID={personID}
				visible={visibleEditProfileModal}
				setVisible={setVisibleEditProfileModal}
			/>
		</Flex>
	);
};

export default RenderHeaderProfileSetting;
